import React from 'react';

const IMAGE_1 = "https://customer-assets.emergentagent.com/job_972f075a-b1e3-4959-8138-fd4cd050246a/artifacts/dnlol66v_4A4F6C20-2F45-4006-8E65-8518DDC24274.png";
const IMAGE_2 = "https://customer-assets.emergentagent.com/job_972f075a-b1e3-4959-8138-fd4cd050246a/artifacts/t18l4jf0_C18228A3-4525-4649-A761-22358072ECAB.png";

const PromoImagesSection = () => {
  return (
    <section className="w-full bg-[#f5f3ef] pt-4 md:pt-5 pb-12 md:pb-20" data-testid="promo-images-section">
      <div className="max-w-5xl mx-auto px-4 md:px-8 flex flex-col gap-10 md:gap-16">
        <img
          src={IMAGE_1}
          alt="Üdvözöllek az oldalamon"
          className="w-full h-auto rounded-sm shadow-sm"
          loading="lazy"
          data-testid="promo-image-welcome"
        />
        <img
          src={IMAGE_2}
          alt="Az első tánc, ami Rólatok szól"
          className="w-full h-auto rounded-sm shadow-sm"
          loading="lazy"
          data-testid="promo-image-services"
        />
      </div>
    </section>
  );
};

export default PromoImagesSection;
